module.exports = __webpack_public_path__ + "img/pt-br_pdf.6cc81ac2.png";